import { render, staticRenderFns } from "./Wireless.vue?vue&type=template&id=61fe5cfc&"
import script from "./Wireless.vue?vue&type=script&lang=js&"
export * from "./Wireless.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports